import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgColor = function SvgColor(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M10.75 17.663a7.5 7.5 0 0 1 0-15c1.99 0 3.897.703 5.303 1.953 1.407 1.25 2.197 2.946 2.197 4.714 0 .884-.395 1.732-1.098 2.357-.704.625-1.657.976-2.652.976h-2.083a1.666 1.666 0 0 0-.834 3.125 1.083 1.083 0 0 1-.833 1.875Z",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M7 9.33a.417.417 0 1 0 0-.833.417.417 0 0 0 0 .833ZM10.75 6.83a.417.417 0 1 0 0-.833.417.417 0 0 0 0 .833ZM14.5 9.33a.417.417 0 1 0 0-.833.417.417 0 0 0 0 .833Z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgColor;